<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Association Alert</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <p class="text-secondary">
      An alert will be visible on the Association Profile until it expires or is dismissed.
    </p>

    <div class="form-group">
      <label for="alertTextInput">Alert Text *</label>
      <input type="text" class="form-control" id="alertTextInput" name="alertText"
             required
             [(ngModel)]="associationAlert.alert_text">
      <div class="form-text text-danger">{{ errors.alert_text }}</div>
    </div>

    <div class="form-group">
      <label for="expiryDateInput">Expiration Date (Optional)</label>
      <app-date-picker [id]="'expiryDateInput'"
                       [(content)]="associationAlert.expiry_date"></app-date-picker>
      <div class="form-text text-danger">{{ errors.expiry_date }}</div>
    </div>

    <div class="form-group">
      <label for="colorHexSelect">Color *</label>
      <app-color-picker [id]="'colorHexSelect'"
                        [(content)]="associationAlert.color_hex"
                        [cpPosition]="'top-right'"></app-color-picker>
      <div class="form-text text-danger">{{ errors.color_hex }}</div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
